import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CUSTOMER_GROUP,
  DELETE_CUSTOMER_GROUP,
  UPDATE_CUSTOMER_GROUP,
  ADD_NEW_CUSTOMER_GROUP,
} from "./actionType";

import {
  getCustomerGroupSuccess,
  getCustomerGroupFail,
  deleteCustomerGroupSuccess,
  deleteCustomerGroupFail,
  updateCustomerGroupSuccess,
  updateCustomerGroupFail,
  addCustomerGroupSuccess,
  addCustomerGroupFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveCustomerGroupApi,
  getCustomerGroupApi,
  updateCustomerGroupApi,
  deleteCustomerGroupApi,
  addNewCustomerGroupApi
} from "../../helpers/backend_helper";

function* getCustomerGroup({ payload: customerGroup }) {
  try {
    const response = yield call(getCustomerGroupApi, customerGroup);
    yield put(getCustomerGroupSuccess(GET_CUSTOMER_GROUP, response.data));
  } catch (error) {
    yield put(getCustomerGroupFail(GET_CUSTOMER_GROUP, error));
  }
}

function* onUpdateCustomerGroup({ payload: customerGroup }) {
  try {
    if (customerGroup.setApprove) {
      const response = yield call(approveCustomerGroupApi, customerGroup);
      yield put(updateCustomerGroupSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCustomerGroupApi, customerGroup);
      yield put(updateCustomerGroupSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCustomerGroupFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCustomerGroup({ payload: customerGroup }) {
  try {
    const response = yield call(deleteCustomerGroupApi, customerGroup);
    yield put(deleteCustomerGroupSuccess({ customerGroup, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCustomerGroupFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCustomerGroup({ payload: customerGroup }) {
  try {
    const response = yield call(addNewCustomerGroupApi, customerGroup);
    yield put(addCustomerGroupSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCustomerGroupFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCustomerGroup() {
  yield takeEvery(GET_CUSTOMER_GROUP, getCustomerGroup);
}

export function* watchUpdateCustomerGroup() {
  yield takeEvery(UPDATE_CUSTOMER_GROUP, onUpdateCustomerGroup);
}

export function* watchDeleteCustomerGroup() {
  yield takeEvery(DELETE_CUSTOMER_GROUP, onDeleteCustomerGroup);
}

export function* watchAddNewCustomerGroup() {
  yield takeEvery(ADD_NEW_CUSTOMER_GROUP, onAddNewCustomerGroup);
}

function* customerGroupSaga() {
  yield all([
    fork(watchGetCustomerGroup),
    fork(watchDeleteCustomerGroup),
    fork(watchUpdateCustomerGroup),
    fork(watchAddNewCustomerGroup)
  ]);
}

export default customerGroupSaga;
